// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"2b2c21de","453":"aedfa237"}[chunkId] + ".chunk.js";
};